import React from 'react'
import { Container, Divider, IconButton, InputAdornment, Checkbox, FormControlLabel } from '@material-ui/core'
import FlexView from 'react-flexview/lib'
import { DatePicker } from '@material-ui/pickers'
import EventIcon from '@material-ui/icons/Event'
import { FirebaseService, FirebaseConfigKey } from '../../services/FirebaseService'
import NewFillButton from '../Core/NewFillButton'
import { EventEmitterService, EventKey } from '../../services/EventEmitterService'
import { awaitWithLoading } from '../../services/utils'
import ReportsApi from '../../api/reports.api'

export const BorderauxAdmin = () => {
  const addOrRemoveDays = (date, days) => {
    const dateOffset = 24 * 60 * 60 * 1000 * days
    return new Date(new Date().setTime(date.getTime() + dateOffset))
  }

  const [borderauxEndDate, setBorderauxEndDate] = React.useState(new Date())
  const [borderauxStartDate, setBorderauxStartDate] = React.useState(addOrRemoveDays(borderauxEndDate, -1))
  const [borderauxIncludeCharges, setBorderauxIncludeCharges] = React.useState(false)

  const onDateChanged = (date, isStart) => {
    if (isStart) {
      setBorderauxStartDate(new Date(date))
    } else {
      setBorderauxEndDate(new Date(date))
    }
  }

  const generateReport = async type => {
    const res = await awaitWithLoading(ReportsApi.generateBordereuxReport(borderauxStartDate, borderauxEndDate, borderauxIncludeCharges))

    if (res.ok) {
      EventEmitterService.dispatch(EventKey.ShowSuccess, {
        title: 'The report is generating now',
        body: 'You will see the reports in the drive in a couple of minutes',
      })
    } else {
      EventEmitterService.dispatch(EventKey.ShowError, res)
    }
  }

  return (
    <Container className="margin-top-basic">
      <div className="text-promotion blue bold">Generate Borderaux Reports</div>
      <Divider />
      <div>
        <div className="bold margin-bottom-small">Borderaux</div>
        <FlexView>
          <DatePicker
            label={'Start Date'}
            id="borderaux_customize_start_date_btn"
            style={{ width: '25%' }}
            disableFuture
            value={borderauxStartDate}
            maxDate={addOrRemoveDays(borderauxEndDate, -1)}
            inputVariant="outlined"
            className="clickable margin-right-basic"
            onChange={e => onDateChanged(e, true, 'borderaux')}
            format={FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)}
            InputProps={{
              disableUnderline: true,
              className: 'lightgrayblue',
              endAdornment: (
                <InputAdornment>
                  <IconButton className="lightgrayblue">
                    <EventIcon fontSize={'small'} className="lightgrayblue" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <DatePicker
            label={'End Date'}
            id="borderaux_customize_end_date_btn"
            style={{ width: '25%' }}
            disableFuture
            value={borderauxEndDate}
            minDate={addOrRemoveDays(borderauxStartDate, 1)}
            inputVariant="outlined"
            className="clickable margin-right-basic"
            onChange={e => onDateChanged(e, false, 'borderaux')}
            format={FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)}
            KeyboardButtonProps={{ className: 'lightgrayblue' }}
            InputProps={{
              disableUnderline: true,
              className: 'lightgrayblue',
              endAdornment: (
                <InputAdornment>
                  <IconButton className="lightgrayblue">
                    <EventIcon fontSize={'small'} className="lightgrayblue" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={borderauxIncludeCharges}
                color="primary"
                onChange={(e, data) => {
                  setBorderauxIncludeCharges(e.target.checked)
                }}
              />
            }
            label="Include Price Report"
          />

          <NewFillButton smallmargintop flat green onClick={() => generateReport('borderaux')}>
            Download Report
          </NewFillButton>
        </FlexView>
      </div>
    </Container>
  )
}
